var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 31,
    viewBox: "0 0 82 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.5C0.895432 17.5 0 16.6046 0 15.5C0 14.3954 0.895432 13.5 2 13.5V17.5ZM81.4142 14.0858C82.1953 14.8668 82.1953 16.1332 81.4142 16.9142L68.6863 29.6421C67.9052 30.4232 66.6389 30.4232 65.8579 29.6421C65.0768 28.8611 65.0768 27.5948 65.8579 26.8137L77.1716 15.5L65.8579 4.18629C65.0768 3.40524 65.0768 2.13891 65.8579 1.35786C66.6389 0.576816 67.9052 0.576816 68.6863 1.35786L81.4142 14.0858ZM2 13.5H80V17.5H2V13.5Z",
    fill: "#009BF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.2349299b00a5f0d6e5bd4bc242fc772c.svg";
export { ForwardRef as ReactComponent };